const convertOutData = (survey) => {
  return {
    survey_id: Number(survey.surveyId),
    survey_name: survey.surveyName,
    survey_title: survey.surveyTitle,
    source: survey.source,
    variant_active_default: survey.variantActiveByDefault,
    // GCS derives captions from the detected sidecar format; W&B has no sidecar
    // format to pick, so it keeps the explicit useCaptions toggle.
    use_captions:
      survey.source === "GCS"
        ? Boolean(survey.captionFormat)
        : Boolean(survey.useCaptions),
    source_config: {
      source: survey.folder,
      api_key: survey.apiKey,
      caption_format: survey.captionFormat || null,
      caption_json_field: survey.captionFormat === "json" ? (survey.captionJsonField || null) : null,
      variant_fields: survey.variantFields || [],
      comparison_scheme: survey.comparisonScheme || "all_pairs",
      reference_variant_name: survey.referenceVariantName || null,
    },
    variants: survey.variants.map((variant) => {
      return {
        variant_id: Number(variant.variantId),
        variant_name: variant.variantName,
        is_active: variant.isActive,
        wandb_id: variant.wandbId,
      };
    }),
    access: survey.access.map((accessItem) => {
      return {
        email: accessItem.email,
        role: accessItem.role,
      };
    }),
  };
};

export { convertOutData };
